import { Box, Stack, styled } from '@mui/material';

export const CreateBoardSlide = styled(Stack)`
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  transition: transform 0.5s;
  margin: -32px -24px;
  overflow: visible;
  height: calc(100% + 64px);
`;

export const CreateBoardSlideItem = styled(Box)`
  position: relative;
  flex: none;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

export const CreateBoardFooterWrapper = styled(Stack)`
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  > p {
    flex: 1;
    text-align: right;
    font-size: 14px;
    color: var(--dk-text-secondary, #888d96);
  }
  button {
    flex: auto;
  }
  &.step-0 {
    button.back,
    button.submit {
      display: none;
    }
  }
  &.step-1 {
    button.save,
    button.preview {
      display: none;
    }
  }
`;
